import { useRef, useState } from "react";
import type { AgreementDocument, RfqItemQuoteInput } from "../../lib/api";

/** Unchanged factual inputs reuse the attempt across failed previews/uncertain
 * sends. Editing starts a new offer; preparing wording records no consent. */
export function useSupplyOfferReview(onPreview: (input: RfqItemQuoteInput) => Promise<{ document: AgreementDocument | null }>) {
  const attempt = useRef<{ fingerprint: string; key: string } | null>(null);
  const [review, setReview] = useState<{ document: AgreementDocument | null; input: RfqItemQuoteInput } | null>(null);
  const [preparing, setPreparing] = useState(false);
  async function prepare(input: RfqItemQuoteInput) {
    const fingerprint = JSON.stringify(input);
    if (attempt.current?.fingerprint !== fingerprint) attempt.current = { fingerprint, key: crypto.randomUUID() };
    const request = { ...input, offerKey: attempt.current.key };
    setPreparing(true);
    try {
      const { document } = await onPreview(request);
      setReview({ document, input: { ...request, ...(document ? { expectedDocumentId: document.id } : {}) } });
    } finally { setPreparing(false); }
  }
  return { review, preparing, prepare, clearReview: () => setReview(null) };
}
